export default __webpack_public_path__ + "static/media/100.6ed310e4.jpg";